import React from 'react';
import { Button } from './ui/button';
import { Lock, CreditCard, XCircle } from "lucide-react";

const PaymentDialog = ({ open, onClose, onProceed }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl shadow-2xl w-96 p-6 text-center border border-slate-200 relative animate-fadeIn">
        {/* Header Icon */}
        <div className="flex justify-center mb-4">
          <div className="bg-blue-100 p-3 rounded-full">
            <Lock className="w-8 h-8 text-blue-600" />
          </div>
        </div>

        {/* Title */}
        <h2 className="text-xl font-semibold text-slate-800 mb-2">
          Payment Required
        </h2>

        {/* Description */}
        <p className="text-slate-600 text-sm mb-6 px-2 leading-relaxed">
          Editing or accessing these tabs requires a paid plan.
They include advanced features beyond the basic version.
To explore and experiment with them, please proceed with the payment to unlock full access.
        </p>

        {/* Buttons */}
        <div className="flex justify-center gap-3">
          <Button
            onClick={onProceed}
            className="bg-blue-600 hover:bg-blue-700 text-white flex items-center gap-2"
          >
            <CreditCard className="w-4 h-4" />
            Proceed to Payment
          </Button>
          <Button
            variant="outline"
            onClick={onClose}
            className="border-slate-300 text-slate-600 flex items-center gap-2"
          >
            <XCircle className="w-4 h-4" />
            Cancel
          </Button>
        </div>
      </div>
      </div>
  );
};

export default PaymentDialog;
